export default __webpack_public_path__ + "img/progress-sm.63564cc2.gif";